export class WeatherCloudRouteDataModel {
  public acc: Array<number>;
  public cloudcover: Array<number>;
  public crosswind: Array<number>;
  public d_precip: Array<number>;
  public d_rad: Array<number>;
  public d_sfc_t: Array<number>;
  public d_snod: Array<number>;
  public delay_risk: Array<number>;
  public dewpt: Array<number>;
  public duration: string;
  public elev: Array<number>;
  public gust: Array<number>;
  public points: string;
  public precip: Array<number>;
  public rad: Array<number>;
  public relhum: Array<number>;
  public residential_roadstate: Array<number>;
  public road_state: Array<number>;
  public road_temp: Array<number>;
  public secondary_roadstate: Array<number>;
  public sfc_t: Array<number>;
  public snod: Array<number>;
  public spd: Array<number>;
  public summary: string;
  public summary_delay_risk: string;
  public temp: Array<number>;
  public vis: Array<number>;
  public vtimes: Array<number>;
  public wdir: Array<number>;
  public xdir: Array<string>;
}
